export const postsKeys = {
  all: ['posts'] as const,
  list: (...args: unknown[]) => [...postsKeys.all, 'list', ...args] as const,
  item: (id: string) => [...postsKeys.all, 'item', id] as const,
};
